const FADE_FALLBACK_MS = 250;

const showWithFade = (element, { displayClass, openClass }, onDisplayed) => {
	if (!element) {
		return;
	}

	element.classList.add(displayClass);
	void element.offsetWidth;
	onDisplayed?.();
	element.classList.add(openClass);
};

const hideWithFade = (element, { displayClass, openClass }) => {
	if (!element) {
		return;
	}

	element.classList.remove(openClass);

	const finish = () => {
		if (!element.classList.contains(openClass)) {
			element.classList.remove(displayClass);
		}
	};

	element.addEventListener(
		'transitionend',
		(e) => {
			if ('opacity' === e.propertyName) {
				finish();
			}
		},
		{ once: true }
	);

	setTimeout(finish, FADE_FALLBACK_MS);
};

export { showWithFade, hideWithFade };
